import { render, staticRenderFns } from "./Weapons.vue?vue&type=template&id=4878ee0c&scoped=true&"
var script = {}
import style0 from "./Weapons.vue?vue&type=style&index=0&id=4878ee0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878ee0c",
  null
  
)

export default component.exports